import React from 'react';
import HeroHeader from '../components/HeroHeader';
import AboutSection from '../components/AboutSection';
import PhotosSection from '../components/PhotosSection';
import RentalsSection from '../components/RentalsSection';
import BookingSection from '../components/BookingSection';
import ProcessSection from '../components/ProcessSection';
import TeamSection from '../components/TeamSection';

export default function Home() {
  const handleReserveClick = () => {
    alert('Reserve button clicked');
  };

  return (
    <div>
      <HeroHeader />
      <AboutSection />
      {/* <PhotosSection /> */}
      <RentalsSection />
      <BookingSection />
      <ProcessSection />
      {/* <TeamSection /> */}
    </div>
  )
}
